import React, { useContext } from 'react';
import Favicon from '../Assets/Icons/favicon_3.png';
import { useAuth } from '../Contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Context_UI } from '../Contexts/Context_UI';
import { useAccounts } from '../Contexts/Context_Accounts';
import { useStatus } from '../Contexts/Context_Status_Global';
import UI_Icon from './ERUMAUI/UI_Icons';

export default function UI_Header() {
    const { Account, Loading } = useAuth();
    const UI = useContext(Context_UI);
    const { List_Unsaved, Status_Saving, Status_Fetching, Page_Properties } = useStatus();
    const { User_Role } = useAccounts();
    const navigate = useNavigate();

    if (Loading) {
        return null;
    }



    const Toggle = () => {
        if (UI.Element_Attribute_Get("Overlay_Header", "State") == "Inactive") {
            UI.Element_Attribute_Set("Overlay_Header", "State", "Active");
            UI.Element_Attribute_Set("Header_Account_Button", "State", "Active");
        } else {
            UI.Element_Attribute_Set("Overlay_Header", "State", "Inactive");
            UI.Element_Attribute_Set("Header_Account_Button", "State", "Inactive");
        }

    }

    return (
        <ui-header>
            <ui-header-panel Left>
                <button className='Header_Navigator' onClick={() => navigate("/home")}>
                    <img className='Header_Navigator_Icon' id="Header_Navigator_Icon" src={Favicon} draggable='false' loading='lazy' alt='' />
                    <h2 className='Header_Navigator_Text' id='Header_Navigator_Text'>
                        {Page_Properties.Properties.Header_Title}
                    </h2>
                </button>
            </ui-header-panel>
            <ui-header-panel Center>
                <h2 className='Header_Title' id='Header_Title'>

                </h2>
            </ui-header-panel>
            <ui-header-panel Right>
                <button className='Header_AccountName' id="Header_Account_Button" State="Inactive" onClick={Toggle}>
                    {Account?.Name_Compounded} ({User_Role})
                </button>
                {List_Unsaved.length !== 0 ?
                    <div className='Header_Status' id='Header_Status_Unsaved' Type="Unsaved">
                        <p className='Header_Status_Subtitle'>
                            There is unsaved data in
                        </p>
                        <h3 className='Header_Status_Title'>
                            {List_Unsaved.join(", ")}
                        </h3>
                    </div>
                    :
                    ""
                }

                {/* {Status_Saving !== "None" ?
                    <div className='Header_Status' id='Header_Status_Save' Type={
                        Status_Saving === "InProgress"
                            ? "Status_InProgress"
                            : Status_Saving === "Error"
                                ? "Status_Error"
                                : Status_Saving === "Success"
                                    ? "Status_Success"
                                    : ""
                        }>
                        <p className='Header_Status_Subtitle'>
                            {
                                Status_Saving === "InProgress"
                                    ? "Input paused"
                                    : Status_Saving === "Error"
                                        ? "An error has occured,"
                                        : Status_Saving === "Success"
                                            ? ""
                                            : ""
                            }
                        </p>
                        <h3 className='Header_Status_Title'>
                            {
                                Status_Saving === "InProgress"
                                    ? "Saving..."
                                    : Status_Saving === "Error"
                                        ? "Saving failed."
                                        : Status_Saving === "Success"
                                            ? "Saving success."
                                            : ""
                            }
                        </h3>
                    </div>
                    :
                    ""
                } */}

                {Status_Saving !== "None" ?
                    <div className='Header_Status' id='Header_Status_Save' Type={
                        Status_Saving === "InProgress"
                            ? "Status_InProgress"
                            : Status_Saving === "Error"
                                ? "Status_Error"
                                : Status_Saving === "Success"
                                    ? "Status_Success"
                                    : ""
                    }>
                        <div className='Header_Status_Icon' State={Status_Saving === "InProgress" ? "Spin_Continuous" : "Still"}>
                            {
                                Status_Saving === "InProgress"
                                    ? <UI_Icon Name="Saving" />
                                    : Status_Saving === "Error"
                                        ? <UI_Icon Name="Error" />
                                        : Status_Saving === "Success"
                                            ? <UI_Icon Name="Check" />
                                            : ""
                            }

                        </div>
                        {/* <div>
                            <p className='Header_Status_Subtitle'>
                                {
                                    Status_Fetching === "InProgress"
                                        ? "Fetching data"
                                        : Status_Fetching === "Error"
                                            ? "An error has occured,"
                                            : Status_Fetching === "Success"
                                                ? ""
                                                : ""
                                }
                            </p>
                            <h3 className='Header_Status_Title'>
                                {
                                    Status_Fetching === "InProgress"
                                        ? "Loading data..."
                                        : Status_Fetching === "Error"
                                            ? "Load failed."
                                            : Status_Fetching === "Success"
                                                ? "Load success."
                                                : ""
                                }
                            </h3>
                        </div> */}

                    </div>
                    :
                    ""
                }

                {/* <div className='Header_Status' id='Header_Status_Save' Type={
                    Status_Fetching === "InProgress"
                        ? "Status_InProgress"
                        : Status_Fetching === "Error"
                            ? "Status_Error"
                            : Status_Fetching === "Success"
                                ? "Status_Success"
                                : ""
                }>
                    <div className='Header_Status_Icon'>
                        <UI_Icon Name="Pending" />
                    </div>
                    <div>
                        <p className='Header_Status_Subtitle'>
                            {
                                Status_Fetching === "InProgress"
                                    ? "Fetching data"
                                    : Status_Fetching === "Error"
                                        ? "An error has occured,"
                                        : Status_Fetching === "Success"
                                            ? ""
                                            : ""
                            }
                            WHAT?
                        </p>
                        <h3 className='Header_Status_Title'>
                            {
                                Status_Fetching === "InProgress"
                                    ? "Loading data..."
                                    : Status_Fetching === "Error"
                                        ? "Load failed."
                                        : Status_Fetching === "Success"
                                            ? "Load success."
                                            : ""
                            }
                            HUHH???
                        </h3>
                    </div>

                </div> */}

                {Status_Fetching !== "None" ?
                    <div className='Header_Status' id='Header_Status_Save' Type={
                        Status_Fetching === "InProgress"
                            ? "Status_InProgress"
                            : Status_Fetching === "Error"
                                ? "Status_Error"
                                : Status_Fetching === "Success"
                                    ? "Status_Success"
                                    : ""
                    }>
                        <div className='Header_Status_Icon' State={Status_Fetching === "InProgress" ? "Spin" : "Still"}>
                            {
                                Status_Fetching === "InProgress"
                                    ? <UI_Icon Name="Pending" />
                                    : Status_Fetching === "Error"
                                        ? <UI_Icon Name="Error" />
                                        : Status_Fetching === "Success"
                                            ? <UI_Icon Name="Check" />
                                            : ""
                            }
                            
                        </div>
                        {/* <div>
                            <p className='Header_Status_Subtitle'>
                                {
                                    Status_Fetching === "InProgress"
                                        ? "Fetching data"
                                        : Status_Fetching === "Error"
                                            ? "An error has occured,"
                                            : Status_Fetching === "Success"
                                                ? ""
                                                : ""
                                }
                            </p>
                            <h3 className='Header_Status_Title'>
                                {
                                    Status_Fetching === "InProgress"
                                        ? "Loading data..."
                                        : Status_Fetching === "Error"
                                            ? "Load failed."
                                            : Status_Fetching === "Success"
                                                ? "Load success."
                                                : ""
                                }
                            </h3>
                        </div> */}
                       
                    </div>
                    :
                    ""
                }

            </ui-header-panel>

        </ui-header>
    );
}
